import retextEnglish, {Parser} from './lib/index.js'

export {Parser}
export default retextEnglish
